import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import global from '@/utils/global'
import comm from '@/utils/comm.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import ajax from './api/https'
import api from './api/api'
import QS from 'qs'
import VueCropper from 'vue-cropper'

Vue.prototype.$ajax = ajax;
Vue.prototype.$api = api;
Vue.prototype.$qs = QS;
Vue.prototype.$comm = comm;
Vue.prototype.$global = global;

Vue.use(ElementUI);
Vue.use(VueCropper);

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});


//跳转
router.beforeEach((to,from,next) => {

	let token = localStorage.getItem('token');

	//判断该路由是否需要登录权限
	if(to.meta.requireAuth){
		if(token){                                     //看token是否存在
			next();  console.log("next");
		}
		else{
			// next('/login');
            console.log("login");
            
            next({
                path: "/login",
                query: {
                    "redirect": encodeURI(to)
                }
            });

		}
	}
	else{
		next();
	}





    // // let isCurBg = Number(to.query.index) ;
    // // localStorage.setItem('isCurBg',isCurBg);


    // //不需要验证登录
    // if (!to.meta.requireAuth) {     console.log("不需要验证登录");
    //     next();
    //     return;
    // }

    // // 确定用户是否已登录
    // const hasToken = !localStorage.getItem("token") ? false : true;
    // //需要验证并且没有登录
    // if (!hasToken) {                 console.log("需要验证并且没有登录");
    //     //返回登录页
    //     next({
    //         path: "/login",
    //         query: {
    //             "redirect": encodeURI(to)
    //         }
    //     });
    //     return;
    // }

    // // 登录
    // if (to.path === '/login') {           console.log("如果已登录，请重定向到主页");
    //     // 如果已登录，请重定向到主页
    //     next({ path: '/index' });
    //     return;
    // }
    
    // next();
})



// WEBPACK FOOTER //
// ./src/main.js